import initAccordion from "../../common/initAccordions.js";

export default () => {
  document.querySelectorAll(".js-accordion-group").forEach((el) => {
    let accordions = [];
    let activeIndex = 0;
    const onlyOne = el.dataset.onlyOne === "true" || false;

    el.querySelectorAll(".js-accordion").forEach((elAccordion, index) => {
      accordions.push(initAccordion(elAccordion, index));

      if (onlyOne) {
        elAccordion
          .querySelector(".js-accordion-link")
          .addEventListener("click", (e) => {
            activeIndex = index;

            // close other accordions
            accordions.forEach((accordion, i) => {
              if (i !== activeIndex) {
                accordion.toggleContent(false);
              }
            });
          });
      }
    });
  });
};
